import { useStore } from '@xyflow/react';
import parse from 'html-react-parser';
import React from 'react';
import { extractCableTypeData } from 'src/utils/export-data';
import { buildLengthMString } from 'src/utils/export/extract';

interface ComponentTableProps {
  scale: number;
  border: string;
}

function ComponentTable({ scale, border }: ComponentTableProps) {
  const edges = useStore((s) => s.edges);
  const nodes = useStore((s) => s.nodes);

  const cableTypeGroups = extractCableTypeData(edges, nodes);

  return (
    <div
      className="absolute overflow-hidden bg-white"
      style={{
        bottom: 0,
        left: 0,
        width: `calc(100% - ${500 * scale}px)`,
        borderRight: border,
        borderTop: border,
      }}
    >
      <div
        className="bg-gray-100 text-center font-bold"
        style={{
          padding: `${4 * scale}px`,
          fontSize: `${11 * scale}px`,
          borderBottom: border,
        }}
      >
        CABLES LIST
      </div>
      <div
        className="overflow-auto"
        style={{ maxHeight: `calc(100% - ${24 * scale}px)` }}
      >
        <table
          className="w-full border-collapse"
          style={{ fontSize: `${8 * scale}px` }}
        >
          <thead>
            <tr className="bg-gray-100" style={{ borderBottom: border }}>
              <th
                className="text-left font-bold"
                style={{
                  padding: `${2 * scale}px ${4 * scale}px`,
                  borderRight: border,
                }}
              >
                TYPE
              </th>
              <th
                className="text-left font-bold"
                style={{
                  padding: `${2 * scale}px ${4 * scale}px`,
                  borderRight: border,
                }}
              >
                LENGTH (M)
              </th>
              <th
                className="text-left font-bold"
                style={{ padding: `${2 * scale}px ${4 * scale}px` }}
              >
                QUANTITY
              </th>
            </tr>
          </thead>
          <tbody>
            {cableTypeGroups.length === 0 ? (
              <tr>
                <td
                  colSpan={3}
                  className="text-center text-gray-500"
                  style={{
                    padding: `${4 * scale}px`,
                    borderBottom: border,
                  }}
                >
                  No cable type data
                </td>
              </tr>
            ) : (
              cableTypeGroups.map((group, index) => {
                const isLast = index === cableTypeGroups.length - 1;
                return (
                  <tr key={`${group.Type}-${index}`}>
                    <td
                      style={{
                        padding: `${2 * scale}px ${4 * scale}px`,
                        borderRight: border,
                        borderBottom: isLast ? 'none' : border,
                      }}
                    >
                      {group.Type || '-'}
                    </td>
                    <td
                      style={{
                        padding: `${2 * scale}px ${4 * scale}px`,
                        borderRight: border,
                        borderBottom: isLast ? 'none' : border,
                        whiteSpace: 'pre-wrap',
                      }}
                    >
                      {parse(buildLengthMString(group['Length (M)']))}
                    </td>
                    <td
                      className="text-center"
                      style={{
                        padding: `${2 * scale}px ${4 * scale}px`,
                        borderBottom: isLast ? 'none' : border,
                      }}
                    >
                      {group.Quantity}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default React.memo(ComponentTable);
